<template>
  <div class="order">
    <van-nav-bar title="意见反馈" left-arrow @click-left="$router.go(-1)" />
    <van-field
      v-model="message"
      rows="4"
      autosize
      label="反馈内容"
      type="textarea"
      maxlength="500"
      placeholder="请输入内容"
      show-word-limit
    />
    <van-button type="primary" class="search-btn" block  @click="submitFeedback">反馈</van-button>

  </div>
</template>

<script>
import { saveFeedback } from '@/api/home'
import { getInfo } from '@/utils/storage'
export default {
  name: 'ChildrenInfo',
  components: {
    
  },
  data () {
    return {
        message: ''


    }
  },
  mounted () {
    
  },
  methods: {
    submitFeedback() {
      if (!this.message) {
        this.$toast('请输入内容')
        return
      }
       const userInfo = getInfo()
      let params = {
        content: this.message,
        uid: userInfo.userId

      }
      saveFeedback(params).then(res => {
       this.$toast('反馈成功')
       this.message = ''
        
      })

    }


  },
  watch: {
    
  }
}
</script>

<style lang="less" scoped>
.order {
  background-color: #fafafa;
}
.search-btn{
  background-color: #04be02;
  color: #fff;
  width: 90%;
  margin: 0 auto;
  font-size: 16px;
  border-radius: 10px;

}
</style>
